import { EventBasketType } from "./EventBasketType";

export function getEventBasketType(): EventBasketType {
  return window["BasketType"] ?? "v2";
}
